import { render, staticRenderFns } from "./PerfectComplimentBlock.vue?vue&type=template&id=11737ec6&scoped=true&"
import script from "./PerfectComplimentBlock.vue?vue&type=script&lang=js&"
export * from "./PerfectComplimentBlock.vue?vue&type=script&lang=js&"
import style0 from "./PerfectComplimentBlock.vue?vue&type=style&index=0&id=11737ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11737ec6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
